import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import ExpertProfileSidebarCard from "../components/ExpertProfile/ExpertProfileSidebarCard";
import ExpertProfileTabs from "../components/ExpertProfile/ExpertProfileTabs";
import { fetchExpertProfile } from "../services/expertProfile/expertProfile";
import type { ExpertProfile } from "../types/Profiles/expertProfile.types";

export default function ExpertProfilePage() {
  const { id_user } = useParams();
  const [activeTab, setActiveTab] = useState("company");
  const [profile, setProfile] = useState<ExpertProfile | null>(null);
  const [profileUserId, setProfileUserId] = useState<number | string | null>(id_user || null);
  const [loading, setLoading] = useState(true);

  const targetUserId = useMemo(() => {
    if (id_user) return id_user;
    const rawUser = localStorage.getItem("user");
    const parsedUser = rawUser ? JSON.parse(rawUser) : null;
    return parsedUser?.id_user || localStorage.getItem("userid");
  }, [id_user]);

  const loadProfile = async (showLoader = false) => {
    try {
      if (showLoader) setLoading(true);

      if (!targetUserId) {
        setProfile(null);
        return;
      }

      setProfileUserId(targetUserId);
      const data = await fetchExpertProfile(targetUserId);
      setProfile(data);
    } catch (error) {
      console.error("Erreur chargement Expert profile:", error);
    } finally {
      if (showLoader) setLoading(false);
    }
  };

  useEffect(() => {
    loadProfile(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetUserId]);

  if (loading) {
    return (
      <div className="container-fluid py-4">
        <div className="card border-0 shadow-sm rounded-4">
          <div className="card-body text-center py-5">
            <div className="spinner-border text-primary" role="status" />
            <p className="mt-3 mb-0">Chargement du profil expert...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="container-fluid py-4">
        <div className="alert alert-warning rounded-4 shadow-sm">Profil expert introuvable.</div>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4">
      <div className="row g-4">
        <div className="col-xl-4 col-lg-5">
          <ExpertProfileSidebarCard
            profile={profile}
            userId={profileUserId}
            onEdit={() => setActiveTab("company")}
            onProfileUpdated={() => loadProfile(false)}
          />
        </div>

        <div className="col-xl-8 col-lg-7">
          <ExpertProfileTabs
            profile={profile}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            userId={profileUserId}
            onProfileUpdated={() => loadProfile(false)}
          />
        </div>
      </div>
    </div>
  );
}
